import React from 'react';

export interface IProps {}

import './graph-legend.scss';

export class GraphLegend extends React.Component <IProps, {}> {
    constructor(props: IProps){
        super(props);
    }

    public render(){
        return <div className="graph-legend-root">
                    <div className="legend-container">
                        <span>
                            <span className="dot source legend-circle"></span>
                            <span className="legend-text">This book</span>
                        </span>
                        <span className="legend-degree">
                            <span className="dot hop1 legend-circle"></span>
                            <span className="legend-text">1°</span>
                        </span>
                        <span className="legend-degree">
                            <span className="dot hop2 legend-circle"></span>
                            <span className="legend-text">2°</span>
                        </span>
                        <span className="legend-degree">
                            <span className="dot hop3 legend-circle"></span>
                            <span className="legend-text">3°</span>
                        </span>
                    </div>
                </div>
    }
}
